//获取预订换台记录
import {http} from "../util/http"
import headers from "./headers"
import {API_KOTLIN_DOMAIN} from "../config"

export const fetchChangeTable=(id) => {
    return http({
        headers: headers(),
        url: `${API_KOTLIN_DOMAIN}/table/reservation/bill/changeTable?id=${id}`,
        method: 'GET',
    })
}


// WEBPACK FOOTER //
// ./src/api/clubReserve.js